"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeTitleFromName = exports.composeLocation = exports.composeLanguage = void 0;

var _expertAutocomplete = require("../expertAutocomplete");

var _staticData = _interopRequireDefault(require("../stores/staticData.store"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 *
 * @param {{firstName: string, countryId?: number}[]} names
 * @returns {{firstName: string, countryId?: number, title?: string}[]} response
 */
var composeTitleFromName = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(names) {
    var result;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!Array.isArray(names) || names.length < 1)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", []);

          case 2:
            _context.next = 4;
            return (0, _expertAutocomplete.getGenderFromName)(names.map(function (e) {
              var _foundCountry;

              var foundCountry = null;

              if (e.countryId) {
                foundCountry = _staticData["default"].countries.find(function (country) {
                  return country.id == e.countryId;
                });
              }

              return {
                names: [{
                  name: e.firstName,
                  country_iso2: (_foundCountry = foundCountry) === null || _foundCountry === void 0 ? void 0 : _foundCountry.isoCode2
                }]
              };
            }));

          case 4:
            result = _context.sent;

            if (!(result && result.length > 0)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", result.map(function (e) {
              var _foundCountry2;

              var foundCountry = null;

              if (e.country_iso2) {
                foundCountry = _staticData["default"].countries.find(function (country) {
                  return country.isoCode2 == e.country_iso2;
                });
              }

              return {
                firstName: e.name,
                countryId: (_foundCountry2 = foundCountry) === null || _foundCountry2 === void 0 ? void 0 : _foundCountry2.id,
                title: e.gender === 'male' ? 'Mr.' : e.gender === 'female' ? 'Ms.' : undefined
              };
            }));

          case 9:
            return _context.abrupt("return", []);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function composeTitleFromName(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 *
 * @param { input: string } input
 * @returns {{ id: number, oldNid: number, name: string, isoCode2: string}}
 */


exports.composeTitleFromName = composeTitleFromName;

var composeLanguageFromText = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(input) {
    var response, sortedLanguages, highestScoredResult;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (input) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", null);

          case 2:
            _context2.next = 4;
            return (0, _expertAutocomplete.getLanguageFromText)(input);

          case 4:
            response = _context2.sent;

            if (!(response && Array.isArray(response.Languages) && response.Languages.length > 0)) {
              _context2.next = 11;
              break;
            }

            // sort by score, descending
            sortedLanguages = response.Languages.sort(function (a, b) {
              return a.Score - b.Score;
            }).reverse(); // get the highest scored language and use that

            highestScoredResult = sortedLanguages[0];
            return _context2.abrupt("return", _staticData["default"].languages.find(function (e) {
              return e.isoCode2 == highestScoredResult.LanguageCode;
            }));

          case 11:
            return _context2.abrupt("return", null);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function composeLanguageFromText(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 *
 * @param {{ text: string, countryId?: number }} input
 * @returns {{ id: number, name: string, updated: boolean, languageToUser: { languageId: number, languageProficiencyId: number }, isoCode2: string }[]}
 */


var composeLanguage = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(input) {
    var _input$text, _foundLanguage, foundCountry, foundlanguages, foundLanguage;

    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(input !== null && input !== void 0 && input.text)) {
              _context3.next = 12;
              break;
            }

            _context3.prev = 1;
            _context3.next = 4;
            return composeLanguageFromText((_input$text = input.text) === null || _input$text === void 0 ? void 0 : _input$text.trim());

          case 4:
            _foundLanguage = _context3.sent;

            if (!_foundLanguage) {
              _context3.next = 7;
              break;
            }

            return _context3.abrupt("return", [{
              id: _foundLanguage.id,
              name: _foundLanguage.name,
              updated: true,
              languageToUser: {
                languageId: _foundLanguage.id,
                languageProficiencyId: 3
              },
              isoCode2: _foundLanguage.isoCode2
            }]);

          case 7:
            _context3.next = 12;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](1);
            console.log("Couldn't find language from text.");

          case 12:
            if (!(input !== null && input !== void 0 && input.countryId)) {
              _context3.next = 24;
              break;
            }

            _context3.prev = 13;
            foundCountry = _staticData["default"].countries.find(function (country) {
              return country.id == input.countryId;
            });

            if (!(foundCountry && foundCountry.languageIds && Array.isArray(JSON.parse(foundCountry.languageIds)))) {
              _context3.next = 19;
              break;
            }

            // Found by country
            foundlanguages = _staticData["default"].languages.filter(function (e) {
              return JSON.parse(foundCountry.languageIds).includes(e.id);
            });

            if (!(Array.isArray(foundlanguages) && foundlanguages.length > 0)) {
              _context3.next = 19;
              break;
            }

            return _context3.abrupt("return", foundlanguages.map(function (e) {
              return {
                id: e.id,
                name: e.name,
                updated: true,
                languageToUser: {
                  languageId: e.id,
                  languageProficiencyId: 3
                },
                isoCode2: e.isoCode2
              };
            }));

          case 19:
            _context3.next = 24;
            break;

          case 21:
            _context3.prev = 21;
            _context3.t1 = _context3["catch"](13);
            console.log("Couldn't find language from country.");

          case 24:
            // English fallback
            foundLanguage = _staticData["default"].languages.find(function (e) {
              return e.isoCode2 === 'en';
            });

            if (!foundLanguage) {
              _context3.next = 27;
              break;
            }

            return _context3.abrupt("return", [{
              id: foundLanguage.id,
              name: foundLanguage.name,
              updated: true,
              languageToUser: {
                languageId: foundLanguage.id,
                languageProficiencyId: 3
              },
              isoCode2: foundLanguage.isoCode2
            }]);

          case 27:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 9], [13, 21]]);
  }));

  return function composeLanguage(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 *
 * @param {{ location?: string, city?: string, state?: string, countryId?: number, timezoneId?: number }} input
 * @returns {{ location?: string, city?: string, state?: string, countryId?: number, timezoneId?: number, country: object }}
 */


exports.composeLanguage = composeLanguage;

var composeLocation = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(input) {
    var splitLocation, _iterator, _step, _loop, _ret, _iterator2, _step2, potentialCity, potentialCityName, searchTerm, foundCountry, cityResponse, _ret2, _searchTerm, _foundCountry4, _cityResponse, placeInfoResponse, extractedPlaceInfoResponse, timezone, _foundCountry5, timezoneResult, _foundCountry6, _extractedPlaceInfoRe2, _foundCountry7, _cityResponse2, _extractedPlaceInfoRe3, _extractedPlaceInfoRe4, _placeInfoResponse, _extractedPlaceInfoResponse, _timezone, _foundCountry8, _timezoneResult, _foundCountry9;

    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (input) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return");

          case 2:
            if (!(input.location && (!input.city || !input.countryId))) {
              _context5.next = 59;
              break;
            }

            splitLocation = input.location.split(', ');

            if (input.countryId) {
              _context5.next = 23;
              break;
            }

            _iterator = _createForOfIteratorHelper(splitLocation);
            _context5.prev = 6;

            _loop = function _loop() {
              var potentialCountry = _step.value;

              var foundCountry = _staticData["default"].countries.find(function (e) {
                return e.name == potentialCountry;
              });

              if (foundCountry) {
                input.countryId = foundCountry.id;
                input.country = foundCountry;
                return "break";
              }
            };

            _iterator.s();

          case 9:
            if ((_step = _iterator.n()).done) {
              _context5.next = 15;
              break;
            }

            _ret = _loop();

            if (!(_ret === "break")) {
              _context5.next = 13;
              break;
            }

            return _context5.abrupt("break", 15);

          case 13:
            _context5.next = 9;
            break;

          case 15:
            _context5.next = 20;
            break;

          case 17:
            _context5.prev = 17;
            _context5.t0 = _context5["catch"](6);

            _iterator.e(_context5.t0);

          case 20:
            _context5.prev = 20;

            _iterator.f();

            return _context5.finish(20);

          case 23:
            if (!(!input.countryId || input.countryId && splitLocation.length != 1)) {
              _context5.next = 59;
              break;
            }

            _iterator2 = _createForOfIteratorHelper(splitLocation);
            _context5.prev = 25;

            _iterator2.s();

          case 27:
            if ((_step2 = _iterator2.n()).done) {
              _context5.next = 51;
              break;
            }

            potentialCity = _step2.value;
            potentialCityName = potentialCity.replace(/(Government|of |the |The |Greater|Metropolitan|Bay |Area|Region|Rhine-Main)/g, '').trim();
            searchTerm = potentialCityName;

            if (input.countryId) {
              foundCountry = _staticData["default"].countries.find(function (e) {
                return e.id == input.countryId;
              });

              if (foundCountry) {
                searchTerm = searchTerm + ' ' + foundCountry.name;
              }
            }

            cityResponse = null;
            _context5.prev = 33;
            _context5.next = 36;
            return (0, _expertAutocomplete.getCitySuggestions)(searchTerm);

          case 36:
            cityResponse = _context5.sent;
            _context5.next = 42;
            break;

          case 39:
            _context5.prev = 39;
            _context5.t1 = _context5["catch"](33);
            // Log error
            console.log('Failed to fetch city suggestions.');

          case 42:
            if (!(cityResponse && cityResponse.length > 0)) {
              _context5.next = 49;
              break;
            }

            return _context5.delegateYield( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
              var _extractedPlaceInfoRe;

              var placeInfoResponse, extractedPlaceInfoResponse, timezone, _foundCountry3, timezoneResult;

              return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      if (cityResponse[0].description.includes(potentialCityName)) {
                        _context4.next = 2;
                        break;
                      }

                      return _context4.abrupt("return", "continue");

                    case 2:
                      placeInfoResponse = null;
                      _context4.prev = 3;
                      _context4.next = 6;
                      return (0, _expertAutocomplete.getPlaceInfoById)(cityResponse[0].place_id);

                    case 6:
                      placeInfoResponse = _context4.sent;
                      _context4.next = 12;
                      break;

                    case 9:
                      _context4.prev = 9;
                      _context4.t0 = _context4["catch"](3);
                      // Log error
                      console.log('Failed to fetch place info by id');

                    case 12:
                      extractedPlaceInfoResponse = null;
                      timezone = null;

                      if (!placeInfoResponse) {
                        _context4.next = 33;
                        break;
                      }

                      _context4.prev = 15;
                      extractedPlaceInfoResponse = (0, _expertAutocomplete.extractPlaceInfo)(placeInfoResponse);
                      _foundCountry3 = _staticData["default"].countries.find(function (e) {
                        return e.id === extractedPlaceInfoResponse.countryId;
                      });

                      if (!_foundCountry3) {
                        _context4.next = 27;
                        break;
                      }

                      if (!_foundCountry3.hasSingleTimezone) {
                        _context4.next = 23;
                        break;
                      }

                      timezone = _staticData["default"].timezones.find(function (e) {
                        return e.name === _foundCountry3.timezoneId;
                      });
                      _context4.next = 27;
                      break;

                    case 23:
                      _context4.next = 25;
                      return (0, _expertAutocomplete.getTimezone)(placeInfoResponse.geometry.location.lat, placeInfoResponse.geometry.location.lng);

                    case 25:
                      timezoneResult = _context4.sent;

                      if (timezoneResult !== null && timezoneResult !== void 0 && timezoneResult.timeZoneId) {
                        timezone = _staticData["default"].timezones.find(function (e) {
                          return e.name === timezoneResult.timeZoneId;
                        });
                      }

                    case 27:
                      _context4.next = 33;
                      break;

                    case 29:
                      _context4.prev = 29;
                      _context4.t1 = _context4["catch"](15);
                      // Log error
                      console.log('Failed to extract place info or get timezone. 1');
                      console.log(JSON.parse(JSON.stringify(_context4.t1)));

                    case 33:
                      if (extractedPlaceInfoResponse) {
                        input.city = extractedPlaceInfoResponse.city;
                        input.state = extractedPlaceInfoResponse.state ? extractedPlaceInfoResponse.state : '';
                        input.countryId = extractedPlaceInfoResponse.countryId ? extractedPlaceInfoResponse.countryId : '';
                      }

                      input.timezoneId = timezone ? timezone.id : (_extractedPlaceInfoRe = extractedPlaceInfoResponse) !== null && _extractedPlaceInfoRe !== void 0 && _extractedPlaceInfoRe.countryDefaultTimezoneId ? extractedPlaceInfoResponse.countryDefaultTimezoneId : '';
                      return _context4.abrupt("return", "break");

                    case 36:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4, null, [[3, 9], [15, 29]]);
            })(), "t2", 44);

          case 44:
            _ret2 = _context5.t2;

            if (!(_ret2 === "continue")) {
              _context5.next = 47;
              break;
            }

            return _context5.abrupt("continue", 49);

          case 47:
            if (!(_ret2 === "break")) {
              _context5.next = 49;
              break;
            }

            return _context5.abrupt("break", 51);

          case 49:
            _context5.next = 27;
            break;

          case 51:
            _context5.next = 56;
            break;

          case 53:
            _context5.prev = 53;
            _context5.t3 = _context5["catch"](25);

            _iterator2.e(_context5.t3);

          case 56:
            _context5.prev = 56;

            _iterator2.f();

            return _context5.finish(56);

          case 59:
            if (!(input.city && (!input.countryId || !input.state || !input.timezoneId))) {
              _context5.next = 107;
              break;
            }

            input.city = input.city.replace(/(Government|of |the |The |Greater|Metropolitan|Bay |Area|Region|Rhine-Main)/g, '').trim();
            _searchTerm = input.city;

            if (input.countryId) {
              _foundCountry4 = _staticData["default"].countries.find(function (e) {
                return e.id == input.countryId;
              });

              if (_foundCountry4) {
                _searchTerm = _searchTerm + ' ' + _foundCountry4.name;
              }
            }

            _cityResponse = null;
            _context5.prev = 64;
            _context5.next = 67;
            return (0, _expertAutocomplete.getCitySuggestions)(_searchTerm);

          case 67:
            _cityResponse = _context5.sent;
            _context5.next = 73;
            break;

          case 70:
            _context5.prev = 70;
            _context5.t4 = _context5["catch"](64);
            // Log error
            console.log('Failed to fetch city suggestions.');

          case 73:
            if (!(_cityResponse && _cityResponse.length > 0 && _cityResponse[0].description.includes(input.city))) {
              _context5.next = 107;
              break;
            }

            placeInfoResponse = null;
            _context5.prev = 75;
            _context5.next = 78;
            return (0, _expertAutocomplete.getPlaceInfoById)(_cityResponse[0].place_id);

          case 78:
            placeInfoResponse = _context5.sent;
            _context5.next = 84;
            break;

          case 81:
            _context5.prev = 81;
            _context5.t5 = _context5["catch"](75);
            // Log error
            console.log('Failed to fetch place info by id');

          case 84:
            extractedPlaceInfoResponse = null;
            timezone = null;

            if (!placeInfoResponse) {
              _context5.next = 105;
              break;
            }

            _context5.prev = 87;
            extractedPlaceInfoResponse = (0, _expertAutocomplete.extractPlaceInfo)(placeInfoResponse);
            _foundCountry5 = _staticData["default"].countries.find(function (e) {
              return e.id === extractedPlaceInfoResponse.countryId;
            });

            if (!_foundCountry5) {
              _context5.next = 99;
              break;
            }

            if (!_foundCountry5.hasSingleTimezone) {
              _context5.next = 95;
              break;
            }

            timezone = _staticData["default"].timezones.find(function (e) {
              return e.name === _foundCountry5.timezoneId;
            });
            _context5.next = 99;
            break;

          case 95:
            _context5.next = 97;
            return (0, _expertAutocomplete.getTimezone)(placeInfoResponse.geometry.location.lat, placeInfoResponse.geometry.location.lng);

          case 97:
            timezoneResult = _context5.sent;

            if (timezoneResult !== null && timezoneResult !== void 0 && timezoneResult.timeZoneId) {
              timezone = _staticData["default"].timezones.find(function (e) {
                return e.name === timezoneResult.timeZoneId;
              });
            }

          case 99:
            _context5.next = 105;
            break;

          case 101:
            _context5.prev = 101;
            _context5.t6 = _context5["catch"](87);
            // Log error
            console.log('Failed to extract place info or get timezone. 2');
            console.log(JSON.parse(JSON.stringify(_context5.t6)));

          case 105:
            if (extractedPlaceInfoResponse) {
              if (!input.countryId) {
                _foundCountry6 = _staticData["default"].countries.find(function (e) {
                  return e.id == extractedPlaceInfoResponse.countryId;
                });
                input.countryId = extractedPlaceInfoResponse.countryId;
                input.country = _foundCountry6;
              }

              if (!input.state) {
                input.state = extractedPlaceInfoResponse.state;
              }
            }

            if (!input.timezoneId) {
              input.timezoneId = timezone ? timezone.id : (_extractedPlaceInfoRe2 = extractedPlaceInfoResponse) !== null && _extractedPlaceInfoRe2 !== void 0 && _extractedPlaceInfoRe2.countryDefaultTimezoneId ? extractedPlaceInfoResponse.countryDefaultTimezoneId : '';
            }

          case 107:
            if (!(input.countryId && (!input.city || !input.state || !input.timezoneId))) {
              _context5.next = 155;
              break;
            }

            _foundCountry7 = _staticData["default"].countries.find(function (e) {
              return e.id == input.countryId;
            });

            if (_foundCountry7 !== null && _foundCountry7 !== void 0 && _foundCountry7.capital && !input.city) {
              input.city = _foundCountry7.capital;
            }

            if (!(!input.state || !input.timezoneId)) {
              _context5.next = 155;
              break;
            }

            _cityResponse2 = null;
            _context5.prev = 112;
            _context5.next = 115;
            return (0, _expertAutocomplete.getCitySuggestions)(input.city + ' ' + _foundCountry7.name);

          case 115:
            _cityResponse2 = _context5.sent;
            _context5.next = 121;
            break;

          case 118:
            _context5.prev = 118;
            _context5.t7 = _context5["catch"](112);
            // Log error
            console.log('Failed to fetch city suggestions.');

          case 121:
            if (!(_cityResponse2 && _cityResponse2.length > 0 && _cityResponse2[0].description.includes(input.city))) {
              _context5.next = 155;
              break;
            }

            _placeInfoResponse = null;
            _context5.prev = 123;
            _context5.next = 126;
            return (0, _expertAutocomplete.getPlaceInfoById)(_cityResponse2[0].place_id);

          case 126:
            _placeInfoResponse = _context5.sent;
            _context5.next = 132;
            break;

          case 129:
            _context5.prev = 129;
            _context5.t8 = _context5["catch"](123);
            // Log error
            console.log('Failed to fetch place info by id');

          case 132:
            _extractedPlaceInfoResponse = null;
            _timezone = null;

            if (!_placeInfoResponse) {
              _context5.next = 153;
              break;
            }

            _context5.prev = 135;
            _extractedPlaceInfoResponse = (0, _expertAutocomplete.extractPlaceInfo)(_placeInfoResponse);
            _foundCountry8 = _staticData["default"].countries.find(function (e) {
              return e.id === _extractedPlaceInfoResponse.countryId;
            });

            if (!_foundCountry8) {
              _context5.next = 147;
              break;
            }

            if (!_foundCountry8.hasSingleTimezone) {
              _context5.next = 143;
              break;
            }

            _timezone = _staticData["default"].timezones.find(function (e) {
              return e.name === _foundCountry8.timezoneId;
            });
            _context5.next = 147;
            break;

          case 143:
            _context5.next = 145;
            return (0, _expertAutocomplete.getTimezone)(_placeInfoResponse.geometry.location.lat, _placeInfoResponse.geometry.location.lng);

          case 145:
            _timezoneResult = _context5.sent;

            if (_timezoneResult !== null && _timezoneResult !== void 0 && _timezoneResult.timeZoneId) {
              _timezone = _staticData["default"].timezones.find(function (e) {
                return e.name === _timezoneResult.timeZoneId;
              });
            }

          case 147:
            _context5.next = 153;
            break;

          case 149:
            _context5.prev = 149;
            _context5.t9 = _context5["catch"](135);
            // Log error
            console.log('Failed to extract place info or get timezone. 3');
            console.log(JSON.parse(JSON.stringify(_context5.t9)));

          case 153:
            if (_extractedPlaceInfoResponse) {
              input.state = _extractedPlaceInfoResponse.state;
            }

            input.timezoneId = _timezone ? _timezone.id : (_extractedPlaceInfoRe3 = _extractedPlaceInfoResponse) !== null && _extractedPlaceInfoRe3 !== void 0 && _extractedPlaceInfoRe3.countryDefaultTimezoneId ? (_extractedPlaceInfoRe4 = _extractedPlaceInfoResponse) === null || _extractedPlaceInfoRe4 === void 0 ? void 0 : _extractedPlaceInfoRe4.countryDefaultTimezoneId : '';

          case 155:
            if (input.countryId && !input.country) {
              _foundCountry9 = _staticData["default"].countries.find(function (e) {
                return e.id == input.countryId;
              });
              input.country = _foundCountry9;
            }

            return _context5.abrupt("return", input);

          case 157:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[6, 17, 20, 23], [25, 53, 56, 59], [33, 39], [64, 70], [75, 81], [87, 101], [112, 118], [123, 129], [135, 149]]);
  }));

  return function composeLocation(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

exports.composeLocation = composeLocation;